import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import { type ProjectMethodologyEnum, SortEnumType } from 'gql/graphql';

import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { catalogOtherCostVariableGroupListGql } from '../CatalogVariableGroupQueries';

export const useGroupList = ({
    catalogUniqueId = '',
    globalOnly = false,
    methodology,
}: {
    catalogUniqueId: string | undefined;
    globalOnly?: boolean;
    methodology: ProjectMethodologyEnum;
}) => {
    const dispatch = useDispatch();

    const variables = useMemo(
        () => ({
            catalogUniqueId,
            globalOnly,
            methodology,
            order: [{ name: SortEnumType.Asc }],
        }),
        [catalogUniqueId, globalOnly, methodology],
    );

    const [resetGroupList] = useResetStoreData({
        requestId: 'catalogOtherCostVariableGroupList',
    });

    useEffect(
        () => () => {
            resetGroupList(undefined);
        },
        [resetGroupList],
    );

    const [groupListData, groupListStatus, , groupListRequest] = useRequest({
        requestId: 'catalogOtherCostVariableGroupList',
        query: catalogOtherCostVariableGroupListGql,
        variables,
        withEffect: Boolean(catalogUniqueId),
    });

    const updateGroupList = useCallback(() => {
        dispatch(groupListRequest(variables));
    }, [dispatch, groupListRequest, variables]);

    return useMemo(
        () => ({
            groupListData: groupListData?.catalogOtherCostVariableGroupList?.items ?? [],
            groupListStatus,
            updateGroupList,
        }),
        [groupListData?.catalogOtherCostVariableGroupList?.items, groupListStatus, updateGroupList],
    );
};
